import { useTheme as useThemeStyled } from "styled-components";

export const useTheme = () => {
  const theme = useThemeStyled() as {
    colors: {
      critical: string;
    };
    breakpoints: {
      xl: number;
      lg: number;
      md: number;
      sm: number;
      xs: number;
      values: {
        xl: number;
        lg: number;
        md: number;
        sm: number;
        xs: number;
      };
    };
  };
  return theme;
};
